import React, {useContext} from "react";
import {NavigationContext} from "@context/NavigationContext";
import BreadcrumbAntd from "./BreadcrumbAntd";
import useCurrentShortcut from "@hooks/useCurrentShortcut";

export const useBreadcrumbComponent = ({ dropLast = false, dropEndingSeparator = false } = {}) => {
    const { trail } = useContext(NavigationContext);
    const { loadShortcutByUrl } = useCurrentShortcut();

    if(!trail.length) return null;

    const displayTrail = dropLast ? trail.slice(0, -1) : trail;

    return function BreadcrumbComponent() {
        return (
            <BreadcrumbAntd showEndingSeparator={!dropEndingSeparator} breadcrumbs={
                displayTrail.map(crumb => {
                    return(
                        {
                            label: crumb.label, function: () => loadShortcutByUrl(crumb.path)
                        }
                    )
                })
            } />
        )
    };
}
